// Import 3rd-party dependencies
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ClipboardModule } from 'ngx-clipboard';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule } from '@angular/cdk/layout';

// Import project-specific dependencies
import { AngularMaterialModule } from '@app/angular-material/angular-material.module';
import { TopNavigationComponent } from '@app/hub/top-navigation/top-navigation.component';
import { HubSharedComponentsModule } from '@app/shared/components/hub-shared-components.module';
import { TrendingComponent } from '@app/hub/trending/trending.component';
import { RecentSharedFilesComponent } from '@app/hub/recent-shared-files/recent-shared-files.component';
import { WorkProfileComponent } from '@app/hub/work-profile/work-profile.component';
import { QuickLinksComponent } from '@app/hub/quick-links/quick-links.component';
import { LatestNewsComponent } from '@app/hub/latest-news/latest-news.component';
import { GlobalFunctionsComponent } from '@app/hub/global-functions/global-functions.component';
import { FeedbackComponent } from '@app/hub/feedback/feedback.component';
import { ToolsAndResourcesComponent } from '@app/hub/tools-and-resources/tools-and-resources.component';
import { HubComponent } from '@app/hub/hub.component';
import { InsightsService } from '@app/core/analytics/services/app-insights-service';
import { AnalyticsModule } from '@app/core/analytics/analytics.module';
import { DirectivesModule } from '@app/directives/directives.module';
import { CalendarEventsComponent } from '@app/hub/calendar-events/calendar-events.component';
import { SearchComponent } from '@app/hub/search/search.component';
import { HubFavoritesComponent } from '@app/hub/favorites/favorites.component';
import { FavoriteWidgetComponent } from '@app/hub/favorite-widget/favorite-widget.component';
import { AddFavoriteDialogComponent } from '@app/hub/add-favorite-dialog/add-favorite-dialog.component';
import { EditFavoriteDialogComponent } from '@app/hub/favorite-widget/edit-favorite-dialog/edit-favorite-dialog.component';
import { CustomToolsResourceControlComponent } from '@app/hub/add-favorite-dialog/custom-tools-resource-control/custom-tools-resource-control.component';
import { PeopleService } from '@app/services/people/people.service';
import { WorldClockComponent } from '@app/hub/world-clock/world-clock.component';
import { ClockDialogComponent } from '@app/hub/world-clock/clock-dialog/clock-dialog.component';
import { ClockSettingsTabComponent } from '@app/hub/world-clock/clock-settings-tab/clock-settings-tab.component';
import { ClockFavoritesTabComponent } from '@app/hub/world-clock/clock-favorites-tab/clock-favorites-tab.component';
import { ViewUserProfileComponent } from '@app/hub/view-user-profile/view-user-profile.component';
import { AnnouncementBannerComponent } from '@app/hub/announcement-banner/announcement-banner.component';
import { TextDefaultPipe } from '@app/core/pipes/text-default.pipe';
import { TrendingHrConnectComponent } from '@app/hub/trending/trending-hrconnect/trending-hrconnect.component';
import { TrendingDocumentsComponent } from '@app/hub/trending/trending-documents/trending-documents.component';
import { NotificationsComponent } from '@app/hub/notifications/notifications.component';
import { NotificationCardComponent } from '@app/hub/notifications/notification-card/notification-card.component';
import { TrendingItConnectComponent } from '@app/hub/trending/trending-itconnect/trending-itconnect.component';
import { AnnouncementsModule } from '../admin/announcements/announcements.module';

let peopleService: PeopleService;

const COMPONENTS = [
  WorldClockComponent,
  ClockDialogComponent,
  ClockSettingsTabComponent,
  ClockFavoritesTabComponent,
  TopNavigationComponent,
  TrendingComponent,
  RecentSharedFilesComponent,
  WorkProfileComponent,
  QuickLinksComponent,
  LatestNewsComponent,
  GlobalFunctionsComponent,
  FeedbackComponent,
  ToolsAndResourcesComponent,
  HubComponent,
  CalendarEventsComponent,
  SearchComponent,
  HubFavoritesComponent,
  FavoriteWidgetComponent,
  AddFavoriteDialogComponent,
  EditFavoriteDialogComponent,
  CustomToolsResourceControlComponent,
  ViewUserProfileComponent,
  AnnouncementBannerComponent,
  TextDefaultPipe,
  TrendingHrConnectComponent,
  TrendingDocumentsComponent,
  NotificationsComponent,
  NotificationCardComponent,
  TrendingItConnectComponent
];

const routes: Routes = [
  {
    path: '',
    component: HubComponent
  }
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    HubSharedComponentsModule,
    AnalyticsModule.forRoot(new InsightsService(peopleService)),
    DirectivesModule,
    NgbModule,
    DragDropModule,
    ScrollingModule,
    ClipboardModule,
    LayoutModule,
    AnnouncementsModule,
    RouterModule.forChild(routes)
  ],
  exports: [...COMPONENTS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class HubModule {}
